// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedAddresses-headerRow-pD8Qv {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 18px;
}

.SavedAddresses-pageTitle-c4tjK {
    font-size: 22px;
    font-weight: 700;
    color: #1F2733;
    margin: 0;
    font-family: 'Poppins', sans-serif;
}

.SavedAddresses-addBtn-HVYni {
    width: auto;
    min-width: 150px;
}

.SavedAddresses-formCard-Jqmiy {
    background: #fff;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    padding: 22px;
    margin-bottom: 24px;
}

.SavedAddresses-formTitle-pl1JJ {
    font-size: 18px;
    font-weight: 600;
    color: #1F2733;
    margin: 0 0 16px;
}

.SavedAddresses-fieldGroup-iOLbX {
    margin-bottom: 16px;
}

.SavedAddresses-typeSelector-nTv61 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 10px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.SavedAddresses-typePill-LK54_ {
    padding: 8px 18px;
    border-radius: 999px;
    border: 1px solid #D9D9D9;
    background: #fff;
    color: #1F2733;
    font-weight: 600;
    cursor: pointer;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
}

.SavedAddresses-typePillActive-qsBtg {
    border-color: #D32F2F;
    background: #FFF6F4;
    color: #D32F2F;
}

.SavedAddresses-formBtnGroup-ASGE6 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px;
    margin-top: 20px;
}

.SavedAddresses-cancelBtn-nGoCK {
    width: auto;
    min-width: 120px;
}

.SavedAddresses-addressList-Wpn8I {
    list-style: none;
    padding: 0;
    margin: 0;
}

.SavedAddresses-addressItem-Jw2ku {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
    padding: 18px;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    margin-bottom: 14px;
    background: #fff;
}

.SavedAddresses-addressInfo-_mSvJ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 4px;
}

.SavedAddresses-addressType-PAfsB {
    display: inline-block;
    -ms-flex-item-align: start;
        align-self: flex-start;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .5px;
    color: #D32F2F;
    background: #FFF6F4;
    border-radius: 6px;
    padding: 2px 10px;
    margin-bottom: 2px;
}

.SavedAddresses-addressName-gOLL3 {
    font-size: 15px;
    font-weight: 600;
    color: #1F2733;
}

.SavedAddresses-addressText-c8yw9 {
    font-size: 14px;
    color: #555;
}

.SavedAddresses-addressActions-dQS_U {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 16px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.SavedAddresses-linkBtn-dFH6W {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-weight: 600;
    color: #1F2733;
}

.SavedAddresses-deleteLink-emgIo {
    color: #D32F2F;
}

.SavedAddresses-emptyText-Hs9W2 {
    color: #777;
    font-size: 15px;
    padding: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/routes/savedAddresses/SavedAddresses.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iCAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,0BAAsB;QAAtB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB","sourcesContent":[".headerRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 18px;\n}\n\n.pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0;\n    font-family: 'Poppins', sans-serif;\n}\n\n.addBtn {\n    width: auto;\n    min-width: 150px;\n}\n\n.formCard {\n    background: #fff;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    padding: 22px;\n    margin-bottom: 24px;\n}\n\n.formTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1F2733;\n    margin: 0 0 16px;\n}\n\n.fieldGroup {\n    margin-bottom: 16px;\n}\n\n.typeSelector {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.typePill {\n    padding: 8px 18px;\n    border-radius: 999px;\n    border: 1px solid #D9D9D9;\n    background: #fff;\n    color: #1F2733;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all .15s ease;\n}\n\n.typePillActive {\n    border-color: #D32F2F;\n    background: #FFF6F4;\n    color: #D32F2F;\n}\n\n.formBtnGroup {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.cancelBtn {\n    width: auto;\n    min-width: 120px;\n}\n\n.addressList {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.addressItem {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    padding: 18px;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    margin-bottom: 14px;\n    background: #fff;\n}\n\n.addressInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.addressType {\n    display: inline-block;\n    align-self: flex-start;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: .5px;\n    color: #D32F2F;\n    background: #FFF6F4;\n    border-radius: 6px;\n    padding: 2px 10px;\n    margin-bottom: 2px;\n}\n\n.addressName {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1F2733;\n}\n\n.addressText {\n    font-size: 14px;\n    color: #555;\n}\n\n.addressActions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n\n.linkBtn {\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    font-weight: 600;\n    color: #1F2733;\n}\n\n.deleteLink {\n    color: #D32F2F;\n}\n\n.emptyText {\n    color: #777;\n    font-size: 15px;\n    padding: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `SavedAddresses-headerRow-pD8Qv`,
	"pageTitle": `SavedAddresses-pageTitle-c4tjK`,
	"addBtn": `SavedAddresses-addBtn-HVYni`,
	"formCard": `SavedAddresses-formCard-Jqmiy`,
	"formTitle": `SavedAddresses-formTitle-pl1JJ`,
	"fieldGroup": `SavedAddresses-fieldGroup-iOLbX`,
	"typeSelector": `SavedAddresses-typeSelector-nTv61`,
	"typePill": `SavedAddresses-typePill-LK54_`,
	"typePillActive": `SavedAddresses-typePillActive-qsBtg`,
	"formBtnGroup": `SavedAddresses-formBtnGroup-ASGE6`,
	"cancelBtn": `SavedAddresses-cancelBtn-nGoCK`,
	"addressList": `SavedAddresses-addressList-Wpn8I`,
	"addressItem": `SavedAddresses-addressItem-Jw2ku`,
	"addressInfo": `SavedAddresses-addressInfo-_mSvJ`,
	"addressType": `SavedAddresses-addressType-PAfsB`,
	"addressName": `SavedAddresses-addressName-gOLL3`,
	"addressText": `SavedAddresses-addressText-c8yw9`,
	"addressActions": `SavedAddresses-addressActions-dQS_U`,
	"linkBtn": `SavedAddresses-linkBtn-dFH6W`,
	"deleteLink": `SavedAddresses-deleteLink-emgIo`,
	"emptyText": `SavedAddresses-emptyText-Hs9W2`
};
module.exports = ___CSS_LOADER_EXPORT___;
